<template>
    <div>
        <WaitingBlock v-if="isGetCurrentDayTemplate"/>
        <div v-else ref="templateToPrint">
            <table>
                <thead>
                    <tr>
                        <th class="print:hide"></th>
                        <th class="print:hide"></th>
                        <th>#</th>
                        <th>Time</th>
                        <th>Duration</th>
                        <th>Artist</th>
                        <th>Title</th>
                        <th>Box</th>
                        <th>Clock</th>
                        <th>Interval</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(track, index) in (sortedPlanning||[])" :class="{'advert':track.trackType==9}" :key="`planning-detail-track-${index}`">
                        <td class="print:hide">
                            <PlayButton class="play-button" :track="track"></PlayButton>
                        </td>
                        <td class="print:hide">
                            <i :class="track._icon"></i>
                        </td>
                        <td class="print:text-small">{{index+1}}</td>
                        <td class="print:text-small">{{track._start.format("HH:mm:ss")}}</td>
                        <td class="print:text-small print:text-center">{{track._duration.format("mm:ss")}}</td>
                        <td>{{track.artist}}</td>
                        <td>{{track.title}}</td>
                        <td class="print:nowrap print:spaced">
                            <span v-if="track.box">
                                <span class="decorator" v-if="track.box">
                                    <i class="fas fa-circle" :style="{ color: track.box.colorCode }" :title="track.box.name"></i>
                                </span>   {{(track.box || {}).name}}
                            </span>
                        </td>
                        <td class="print:nowrap print:spaced">
                            <span v-if="track.clock">
                                <span class="decorator">
                                    <i class="fas fa-circle" :style="{ color: track.clock.colorCode }" :title="track.clock.name"></i>
                                </span>{{(track.clock || {}).name}}
                            </span>
                        </td>
                        <td class="print:text-small print:nowrap">
                            <span v-if="track.clock">
                                {{track.clock._startTime.format("HH:mm")}} - {{track.clock._endTime.format("HH:mm")}}
                            </span>
                        </td>

                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="7"></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
    import Moment from 'moment';
    import { HTTP } from '@/utils/http';
    import Apis from '@/apis/index';
    import { setTimeout } from 'timers';
    import WaitingBlock from'@/components/common/WaitingBlock'
    import Enums from '../../apis/_enums'
    import {mapActions, mapState} from 'vuex';
    import store from '@/store';
    import EventBus from '@/eventbus';
    import { arrayToCsv } from '@/utils/exportToCsv';
    import PlayButton from "@/components/common/PlayButton";
    import {safeObj} from "@/utils/safeObj";

    export default {
        name: 'PlanningDetails',
        components: {PlayButton, WaitingBlock },
        computed: {
            ...mapState({
                currentDayTemplate: state => state.Templates.currentDayTemplate,
                isGetCurrentDayTemplate: state => state.Templates.isGetCurrentDayTemplate,
            }),
            scheduledDate() {
                return Moment(this.$route.params.planningDate);
            },
            trackTypes() { return Enums.TrackTypes; },
            sortedPlanning() {
                return safeObj(this.currentDayTemplate) && this.currentDayTemplate.planning
                    .map(itm => {
                        var tr = {
                            _start: Moment(itm.startTime, "HH:mm:ss"),
                            _duration: Moment(itm.duration, "HH:mm:ss"),
                            _icon: this.getIcon(itm.trackType),
                            uid: itm.trackUid
                        };

                        if (itm.clock) {
                            itm.clock._startTime = Moment(itm.clock.start, "HH:mm:ss");
                            itm.clock._endTime = Moment(itm.clock.end, "HH:mm:ss");
                        }
                        return Object.assign(tr, itm)
                    })
                    .sort((a, b) => (a._start < b._start) ? -1 :
                        (a._start === b._start) ? 0 : 1
                    )
                    .filter(tr => {
                        const title = tr.title.toLowerCase();
                        const artist = tr.artist.toLowerCase();
                        const terms = this.terms.toLowerCase();
                        return title.search(terms) >= 0 || artist.search(terms) >= 0 || (tr.box.name && tr.box.name.toLowerCase().search(terms) >= 0);
                    });
                //return elts;
            },
            dataToExportToCsv() {
                return this.sortedPlanning.map((arr, index) => ({
                    Position: index+1,
                    Time: arr.startTime,
                    Duration: arr.duration,
                    Artist: arr.artist,
                    Title: `${arr.title}    `,
                    Box: `${arr.box.name}`,
                    Clock: arr.clockName,
                    Interval: `${arr.clock.start} - ${arr.clock.end}`
                }))
            }
        },
        mounted() {
            //this.loadData();
            EventBus.$on('planningSearch', this.setTerms);
            EventBus.$on('printDayTemplate', () => {this.printTemplate('templateToPrint') });
            EventBus.$on('exportDayTemplate', () => { this.exportToCsv(this.dataToExportToCsv) });
        },

        watch: {
            '$route': function (to, from) {
                //this.loadData();
                // this.$store.dispatch('Templates/getCurrentDayTemplate', {
                //     scheduleDate: this.scheduledDate.format("YYYY-MM-DD"),
                //     stationUid: this.$route.params.stationUid
                // });
            },
        },

        beforeDestroy() {
            clearInterval(this.polling)
        },
        data() {
            return {
                // viewState: {
                //     isLoading: false
                // },
                //planningData: null,
                // response: null,
                terms: ''
            }
        },
        async beforeMount(){
            await this.$store.dispatch('Templates/getCurrentDayTemplate', {
                scheduleDate: this.scheduledDate.format("YYYY-MM-DD"),
                stationUid: this.$route.params.stationUid
            });
        },
        methods: {
            getIcon(trackType) {
                return (this.trackTypes[trackType] || {}).icon;
            },
            // onApiLoaded(response) {
            //     // console.log(response);
            //     this.planningData = response.data.dataItem
            //     store.commit("onPlanningDataLoaded",this.planningData);
            // },
            // onApiError(error) {
            //     this.planningData = error.response.data.dataItem
            // },
            // onApiCompleted() {
            //     this.viewState.isLoading = false;
            // },
            // loadData() {
            //     store.commit("onPlanningDataLoaded", this.planningData);
            //     // console.log("reload")
            //     this.viewState.isLoading = true;
            //     HTTP.get(Apis.planning.details, {
            //         params: {
            //             scheduleDate: this.scheduledDate.format("YYYY-MM-DD"),
            //             stationUid: this.$route.params.stationUid
            //         }
            //     })
            //         .then(this.onApiLoaded, this.onApiError)
            //         .then(this.onApiCompleted);
            // },
            setTerms(terms) {
                this.terms = terms;
            },
            exportToCsv(data){
                arrayToCsv(data, 'export')
            },
            printTemplate (ref) {
                const printContents = `<title>${this.scheduledDate.format('YYYY-MM-DD')} - ${this.currentDayTemplate.dayTemplate.name}</title>` + this.$refs[ref].innerHTML + '<style>body { font-size: 12px; } .print\\\:hide, .decorator { display: none; } .print\\\:text-center { text-align: center; } .print\\\:text-small { font-size: small; } tr > * { border-bottom: 1px solid #D2D2D2; } .print\\\:nowrap { white-space: nowrap; } .print\\\:spaced { padding: 0 5px; } @page { size: landscape; }</style>'
                const printWindow = window.open()
                printWindow.document.write(printContents)
                printWindow.document.close()
                printWindow.focus()
                printWindow.print()
                setTimeout(() => {
                    printWindow.close()
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    table {
        width: 100%;
    }

    thead, thead tr:nth-child(1) th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        background: white;
    }

    thead tr:nth-child(1) th {
        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: #D2D2D2;
        }
    }

    td, th {
        padding: 15px 15px 15px 0;
        font-size: 13px;
        line-height: 16px;
    }

        td span {
            white-space: nowrap;
        }

            td span .decorator {
                margin-right: 10px;
            }

    th {
        color: #AAAAAA;
        padding: 22px 15px 22px 0;
    }

    tbody tr {
        color: #292C33;
        font-size: 13px;
        line-height: 16px;
        border-bottom: 1px solid #D2D2D2;
    }

    i {
        color: #D2D2D2;
    }
    .control{
        display: flex;
        justify-content: flex-end;
        padding: 10px;
    }
    .play-button{
        padding-left: 10px;
        color: #aaa;
    }
</style>

